import { useLocation as commonUseLocation } from "packages/react-router-dom";

export const useLocation = commonUseLocation;
